
import React from "react";

interface InstructionBoxProps {
  children: React.ReactNode;
  className?: string;
}

const InstructionBox: React.FC<InstructionBoxProps> = ({ children, className = "" }) => {
  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-md p-4 ${className}`}>
      {children}
    </div>
  );
};

export default InstructionBox;
